import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../../PageHeader';
import CorporateSectionLayout from '../../../CorporateSectionLayout';
import Piagam from './Piagam';
import Charter from './Charter';

function PiagamCharterLayout() {
    const items = [
        { id: 'piagam', number: '01', label: 'Piagam', content: <Piagam /> },
        { id: 'charter', number: '02', label: 'Charter', content: <Charter /> },
    ];
    return <>
        <Helmet><title>Piagam / Charter | PT Len Telekomunikasi Indonesia</title><meta name="description" content="Piagam/Charter PT Len Telekomunikasi Indonesia." /><link rel="canonical" href="https://www.len-telko.co.id/tata-kelola-perusahaan/piagam-charter" /></Helmet>
        <PageHeader title="Piagam / Charter" />
        <CorporateSectionLayout title="Piagam / Charter" eyebrow="Tata Kelola Perusahaan" items={items} />
    </>;
}
export default PiagamCharterLayout;
